var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72203 14.9279C3.537 12.8616 2.96481 11.1743 2.6198 9.46402C2.10953 6.93447 3.27726 4.46351 5.21173 2.88684C6.02931 2.22048 6.96654 2.44815 7.45 3.3155L8.54148 5.27364C9.40661 6.82571 9.83918 7.60174 9.75338 8.42449C9.66758 9.24724 9.08421 9.91733 7.91747 11.2575L4.72203 14.9279ZM4.72203 14.9279C7.12063 19.1103 10.8848 22.8766 15.0721 25.278M15.0721 25.278C17.1384 26.463 18.8257 27.0352 20.536 27.3802C23.0655 27.8905 25.5365 26.7227 27.1132 24.7883C27.7795 23.9707 27.5519 23.0335 26.6845 22.55L24.7264 21.4585C23.1743 20.5934 22.3983 20.1608 21.5755 20.2466C20.7528 20.3324 20.0827 20.9158 18.7425 22.0825L15.0721 25.278Z",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.53982C19.2791 9.2953 20.7047 10.721 21.4602 12.5M18.3175 2.5C22.739 3.77595 26.2239 7.26065 27.5 11.682",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.62366def9dda621b33d5a67b1a2f5412.svg";
export { ForwardRef as ReactComponent };